var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Categories"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0782 7.6175C17.3236 7.6175 18.3332 6.6079 18.3332 5.3625C18.3332 4.1171 17.3236 3.1075 16.0782 3.1075C14.8328 3.1075 13.8232 4.1171 13.8232 5.3625C13.8232 6.6079 14.8328 7.6175 16.0782 7.6175Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.92151 7.6175C7.16691 7.6175 8.1765 6.6079 8.1765 5.3625C8.1765 4.1171 7.16691 3.1075 5.92151 3.1075C4.67611 3.1075 3.6665 4.1171 3.6665 5.3625C3.6665 6.6079 4.67611 7.6175 5.92151 7.6175Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.0782 18.8925C17.3236 18.8925 18.3332 17.8829 18.3332 16.6375C18.3332 15.3921 17.3236 14.3825 16.0782 14.3825C14.8328 14.3825 13.8232 15.3921 13.8232 16.6375C13.8232 17.8829 14.8328 18.8925 16.0782 18.8925Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.92151 18.8925C7.16691 18.8925 8.1765 17.8829 8.1765 16.6375C8.1765 15.3921 7.16691 14.3825 5.92151 14.3825C4.67611 14.3825 3.6665 15.3921 3.6665 16.6375C3.6665 17.8829 4.67611 18.8925 5.92151 18.8925Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.7621d197e6572499a2df628b8d656967.svg";
export { ForwardRef as ReactComponent };